function setupCachedXhr(xhr, xhrProxy, cacheInstance) {
    xhrProxy._cacheInstance = cacheInstance;
}

export default setupCachedXhr;


// WEBPACK FOOTER //
// ./src/setup-cached-xhr.js